const ErrorCodes = {
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    ERR_BAD_REQUEST: 'ERR_BAD_REQUEST',
};

export default ErrorCodes;
